"use client"

import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { TextField } from './TextField'

function KeywordFilter() {
  const router = useRouter()
  const [keyword, setKeyword] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const keywordParam = params.get('keyword') || ''
      setKeyword(keywordParam)
    }
  }, [])

  const handleKeywordBlur = (value: string) => {
    setKeyword(value)
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      if (value.length >= 3) {
        params.set('keyword', value)
      } else {
        params.delete('keyword')
      }
      router.push(`${window.location.pathname}?${params.toString()}`)
    }
  }

  return (
    <div>
      <h3 className="font-semibold mb-2">Keyword</h3>
      <div className="relative">
        <TextField
          value={keyword}
          onChange={(value) => handleKeywordBlur(value)}
          placeholder="Search (min. 3 characters)"
          maxLength={100}
        />
      </div>
    </div>
  )
}

export default KeywordFilter